<template>
    <div class="table-list employee-role-list">
        <member-list :obj="selectedObj"></member-list>
        <modal class="del-role" :display="modalState.delRoleModal" @modalStatus="closeModal('delRoleModal')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除職務部門</h1>
            <div class="content">
                確定要刪除“{{delRole.roleName}}”角色嗎？確定後將直接刪除此職務部門
            </div>
            <div class="btn-group">
                <button class="default-button" @click="delEmployeeRole()">確認</button>
                <button class="border-button" @click="closeModal('delRoleModal')">取消</button>
            </div>
        </modal>

        <div class="mask"></div>
        <div class="table-list-title">
            <span class="role">職務部門</span>
            <span class="members">成員</span>
            <span class="auth">權限</span>
            <span class="create-date">建立時間</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && employeeRoleList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="employeeRoleList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="role">{{list.roleName}}</span>
                    <span class="members" @click="openMemberList(list)">{{getMemberShowText(list.memberAmount)}}</span>
                    <span class="auth" v-if="list.authorityList.length == 0">無</span>
                    <span class="auth" v-else>{{list.authorityList.join()}}</span>
                    <span class="create-date">{{getFormatDateTime(list.createdDate)}}</span>
                    <span class="action">
                        <dot-drop-menu>
                            <ul>
                                <router-link :to="{ name: 'bizViewEmployeeRole', query: {id: list.id}}">
                                    <li :roleId="list.id">查看職務部門</li>
                                </router-link>
                                <li v-if="bizAuth.editRole.hasRight && list.managerRole" @click="$store.dispatch('setAlarmStatus', {status: true,title: '管理者權限不得編輯',type: 'error', closeBtn: true})">編輯職務部門</li>
                                <router-link  :to="{ name: 'bizEditEmployeeRole', query: {id: list.id}}"
                                    v-else-if="bizAuth.editRole.hasRight">
                                    <li :roleId="list.id">編輯職務部門</li>
                                </router-link>
                                <li v-if="bizAuth.deleteRole.hasRight" @click="delRole.roleId = list.id, delRole.roleName = list.roleName, openModal(list)">刪除職務部門</li>
                            </ul>
                        </dot-drop-menu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import memberList from '@/components/bussiness/widges/modals/memberList.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return{
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            modalState: {
                delRoleModal: false
            },
            delRole: {
                roleId: null,
                roleName: null,
            },
            selectedObj: null,
            isLoading: true
        }
    },
    props: {
        
    },
    mounted () {
        this.getEmployeeRoleList();
    },
    methods: {
        openMemberList: function (list) {
            this.selectedObj = list
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizMemberList'})
        },
        getEmployeeRoleList: function () {
            this.$store.dispatch('getBizEmployeeRoleList')
            .then(()=>{
                this.isLoading = false
            })
        },
        getMemberShowText: function(rawText) {
            if(rawText == undefined){
                rawText = 0
            }
            return rawText + " 位"
        },
        setFilterDefault: function () {
        
        },
        // 刪除角色
        delEmployeeRole: function () {
            this.$analyticsBiz.logEvent('刪除職務部門', { screen_name: '職務部門列表'})
            this.$store.dispatch('delBizEmployeeRole', this.delRole.roleId)
            .then(res => {
                if(res.data.status = "SUCCESS"){
                    this.modalState.delRoleModal = false
                    this.getEmployeeRoleList()
                    if(res.data.errorMsg){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                console.log(err)
            })
        },
        openModal: function (item) {
            if(item.memberAmount){
                this.$store.dispatch('setAlarmStatus', {status: true,title: '職務部門下有成員不可刪除',type: 'error', closeBtn: true})
            }else{
                this.modalState.delRoleModal = true
            }
        },
        // 關閉角色modal
        closeModal: function () {
            this.modalState.delRoleModal = false
        },
    },
    computed: {
        filterByWord: function () {
            return this.employeeRoleList.filter((item) => {
                if( this.filterWord ){
                    if( item.roleName.includes(this.filterWord)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            employeeRoleList: 'GET_BIZ_EMPLOYEE_ROLE_LIST',
            filterWord: 'GET_BIZ_EMPLOYEE_ROLE_FILTER_WORD',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        DotDropMenu,
        Modal,
        memberList,
        tableLoading
    }
}
</script>
<style lang="scss">
    .table-list.employee-role-list{
        margin-bottom: 150px;
        .table-list-title .role,
        .table-list-body ul li .role{
            width: 90px;
            margin-right: 65px;
        }
        .table-list-title .members,
        .table-list-body ul li .members{
            width: 100px;
            margin-right: 72px;
        }
        .table-list-body ul li .members{
            color: #ff9275;
            cursor: pointer;
        }
        .table-list-title .auth,
        .table-list-body ul li .auth{
            width: 400px;
            margin-right: 138px;
        }
        .table-list-title .create-date,
        .table-list-body ul li .create-date{
            width: 72px;
            margin-right: 111px;
        }
        .table-list-title .action,
        .table-list-body ul li .action{
            width: 28px;
        }

        #modal.del-role{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px){
        // .table-list.employee-role-list{
            
        // }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/internalAuth/employeeRole/employeeRoleList.vue